<template>
  <Card class="type">
    <div class="type__show">
      <Tabs
        v-model="type"
        @tab-click="handleTabClick"
      >
        <TabPane
          v-for="item in tabs"
          :key="item.key"
          :label="item.name"
          :name="item.key"
        />
      </Tabs>
    </div>

    <Table
      v-loading="tableLoading"
      v-fixed
      class="type__table"
      border
      :data="tableData"
      :header-cell-style="tableHeaderStyle"
      :span-method="objectSpanMethod"
    >
      <TableColumn
        label="客户类型"
        prop="type"
        width="100px"
      />
      <TableColumn
        label="日期"
        prop="date"
        width="100px"
      >
        <template slot-scope="scope">
          {{ scope.row.date.split(' ')[0] }}
        </template>
      </TableColumn>
      <TableColumn
        v-for="item in columns"
        :key="item.prop"
        :label="item.label"
        :prop="item.prop"
        :width="item.width"
        align="right"
      >
        <template slot-scope="scope">
          <TableCell :dataSource="scope" />
        </template>
      </TableColumn>
    </Table>
  </Card>
</template>

<script>
import { Card, Table, TableColumn, Tabs, TabPane } from 'element-ui';

import TableCell from '../components/TableCell';
import Request from '@/core/QuRequest';
import columns from './columns';
import { createTypeTableData } from '../utils/formatData';
const req = new Request();

export default {
  components: {
    Card,
    Table,
    TableColumn,
    Tabs,
    TabPane,

    TableCell,
  },

  props: {
    date: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      type: 'account_type',
      tabs: [
        {
          key: 'account_type',
          name: '按客户类型',
        },
        {
          key: 'adslot_type',
          name: '按栏位类型',
        },
        {
          key: 'media_type',
          name: '按媒体类型',
        },
        {
          key: 'category',
          name: '按行业类型',
        },
        {
          key: 'inside_type',
          name: '内部详情',
        },
      ],
      tableData: [],
      tableLoading: false,
      field: 'cost_total',
    };
  },

  computed: {
    columns() {
      return columns(this.type);
    },
  },

  watch: {
    date() {
      this.volatilityGetByType();
    },
  },

  created() {
    this.volatilityGetByType();
  },

  methods: {
    tableHeaderStyle({ rowIndex }) {
      if (rowIndex === 0) {
        return 'background-color: #F2F9FF';
      }
    },

    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % 4 === 0) {
          return {
            rowspan: 4,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },

    async volatilityGetByType() {
      this.tableLoading = true;
      try {
        const params = {
          date: this.date[0].format('YYYY-MM-DD'),
          compare_date: this.date[1].format('YYYY-MM-DD'),
          type: this.type,
        };

        const res = await req.send(
          req.Apis.sales.report.volatilityGetByType,
          params,
        );

        this.tableLoading = false;

        if (res && res.code === 200) {
          const data = createTypeTableData(res.data);
          this.tableData = data;
        }
      } catch (err) {
        this.tableLoading = false;
        this.$message.error(err.message);
      }
    },

    handleTabClick() {
      this.volatilityGetByType();
    },
  },
};
</script>

<style lang="less" scoped>
.type {
  margin-top: 24px;

  &__show {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__table {
    margin-top: 24px;
  }

  &__rate {
    font-size: 14px;
    font-weight: 400;
    color: rgba(48, 49, 51, 1);
    margin-top: 24px;

    &--icon {
      margin-left: 6px;
      cursor: pointer;
    }
  }
}
</style>